import ReportsVisitsSection from './Visits';
import ReportsDownloadSection from './Download';
import ReportsDownloadUserSatifaction from './UserSatifaction';
import ReportsHeatmapSection from './Heatmap';

const ReportsSectionsComponents = {
  Visits: ReportsVisitsSection,
  Download: ReportsDownloadSection,
  UserSatifaction: ReportsDownloadUserSatifaction,
  Heatmap: ReportsHeatmapSection,
};

export default ReportsSectionsComponents;
